import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import idx from 'idx';
import { PACKAGE_SELECTOR_DESCRIPTIONS } from 'pap/constants';
import { getPackageSelectorFeatures } from 'pap/utils';
import Question from 'help/components/question';

export default class PackageDetails extends Component {
  constructor(props) {
    super(props);

    this.closeDetails = this.closeDetails.bind(this);
    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
  }

  prev(e) {
    const { packages, pack, displayFullScreen } = this.props;
    e.preventDefault();
    displayFullScreen("package_details", packages[packages.findIndex(p => p.id === pack.id) - 1]);
  }

  next(e) {
    const { packages, pack, displayFullScreen } = this.props;
    e.preventDefault();
    displayFullScreen("package_details", packages[packages.findIndex(p => p.id === pack.id) + 1]);
  }

  closeDetails(e) {
    e.preventDefault();
    this.props.hideFullScreen();
  }

  renderAwards() {
    const { pack } = this.props;
    const awardsTotal = pack.awards.slice(0, pack.min_awards).reduce(
      (acc, award) => acc + award.feature.value, 0
    );

    if (!awardsTotal) {
      return null;
    }

    return (
      <span>
        <span className="dollar-sign">$</span>{ awardsTotal } award
      </span>
    );
  }

  renderRankedTips() {
    const { pack } = this.props;
    const rankedTipsTotal = (pack.package_tips || []).reduce((acc, t) => acc + t.feature.value, 0);

    if (!rankedTipsTotal) {
      return null;
    }

    return (
      <span>
        {' '}  / <span className="dollar-sign">$</span>{ rankedTipsTotal } tips
      </span>
    );
  }

  renderFeature(f, i) {
    return (
      <dl key={i} className={classnames("columns small-16 large-7", { "large-offset-2": i % 2 == 1 })}>
        <dt><i className="fa fa-check" /> { f.detailsName }</dt>
        <dd>{ f.description }</dd>
        { !!f.question &&
        <div className="faq">
          <Question question={f.question} answer={f.answer} />
        </div> }
      </dl>
    );
  }

  render() {
    const { pack, fullScreen, subCategory, onSelect, packages } = this.props;

    if (idx(fullScreen, _ => _.extraData.name) !== pack.name) {
      return null;
    }

    const features = getPackageSelectorFeatures({
      packSlug: pack.slug,
      subcatSlug: idx(subCategory, _ => _.slug)
    });

    const includedFeatures = features.filter(f => !!f.included);
    const optionalFeatures = features.filter(f => !!f.optional);

    return (
      <div className={classnames("package-details",  "package-" + pack.name.toLowerCase())}>
        { packages.findIndex(p => p.id === pack.id) > 0 &&
        <button className="show-for-large btn-left" onClick={this.prev}>
          <i className="fa fa-angle-left" />
        </button> }
        { packages.findIndex(p => p.id === pack.id) < packages.length - 1 &&
        <button className="show-for-large btn-right" onClick={this.next}>
          <i className="fa fa-angle-right" />
        </button> }
        <button className="btn-close modal fa fa-times-circle" onClick={this.closeDetails} />
        <div className="row align-center">
          <div className="columns medium-10 small-16">
            <h1 className="package-headline">{ pack.name } package</h1>
            <span className="package-subhead">{ PACKAGE_SELECTOR_DESCRIPTIONS[pack.slug] }</span>
          </div>

          <div className="columns medium-6 small-16">
            <div className="pricing">
              <div className="cost">
                <span className="dollar-sign">$</span>{ Math.floor(pack.base_price) }
              </div>
              <div className="award">
                { this.renderAwards() }{ this.renderRankedTips() } included
              </div>
            </div>
          </div>
        </div>

        <div className="row align-center">
          <div className="columns small-16">
            <h3 className="package-list-headline">Included features:</h3>
          </div>
          <div className="columns small-16">
            <div className="package-feature-list included">
              <div className="row">
                { includedFeatures.map(this.renderFeature) }
              </div>
            </div>
          </div>
        </div>

        { optionalFeatures.length > 0 &&
        <div className="row align-center">
          <div className="columns small-16">
            <h3 className="package-list-headline">Optional features:</h3>
          </div>
          <div className="columns small-16">
            <div className="package-feature-list">
              <div className="row">
                { optionalFeatures.map(this.renderFeature) }
              </div>
            </div>
          </div>
        </div> }

        <div className="row align-center actions">
          <div className="columns small-16">
            <button className="btn btn-primary" onClick={onSelect}>
              Select { pack.name } package
            </button>
            <button className="btn btn-text" onClick={this.closeDetails}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PackageDetails.propTypes = {
  pack: PropTypes.object.isRequired,
  fullScreen: PropTypes.object,
  subCategory: PropTypes.object.isRequired,
  hideFullScreen: PropTypes.func.isRequired,
  displayFullScreen: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  packages: PropTypes.array.isRequired,
};
